module.exports = __webpack_public_path__ + "static/media/icon-author.20f8ee08.svg";